import { ReactElement } from 'react';

const DarkThemeIcon = ({ childClass, className }: TClassNameProps): ReactElement => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" className={className}>
		<path
			d="M1.52103 9.33774C1.79982 13.4567 5.184 16.8078 9.23417 16.9918C12.0917 17.1197 14.6473 15.7441 16.1806 13.5767C16.8156 12.6889 16.4749 12.097 15.414 12.297C14.8951 12.393 14.3608 12.4329 13.8032 12.409C10.0163 12.249 6.91868 8.97783 6.90319 5.11482C6.89544 4.07509 7.10454 3.09134 7.484 2.19557C7.90218 1.20382 7.39881 0.731944 6.4308 1.15584C3.36413 2.49149 1.26548 5.68267 1.52103 9.33774Z"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
			className={childClass}
		/>
	</svg>
);

export default DarkThemeIcon;
